import React from 'react'

import { Box } from 'widgets/Box'

export const NoContent = ({ children }: { children: React.ReactNode }) => {
  return <Box flex={1}>{children}</Box>
}
